import { ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import { BackButton } from '@/components/ui/BackButton';

interface StoreFormHeaderProps {
  title: string;
  description: string;
  onCancel: () => void;
  onSubmit: () => void;
  submitLabel: string;
  cancelLabel: string;
  isSubmitting: boolean;
  children?: ReactNode;
}

/**
 * Store form header component
 * Displays navigation, title, description and action buttons
 */
export const StoreFormHeader = ({
  title,
  description,
  onCancel,
  onSubmit,
  submitLabel,
  cancelLabel,
  isSubmitting,
  children,
}: StoreFormHeaderProps) => {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
          <p className="text-muted-foreground mt-1 text-sm">{description}</p>
        </div>
      </div>
      <div className="flex gap-2">
        {children}
        <Button type="button" variant="outline" size="sm" onClick={onCancel} disabled={isSubmitting}>
          {cancelLabel}
        </Button>
        <Button
          id="create-store-submit-button"
          type="submit"
          size="sm"
          disabled={isSubmitting}
          onClick={onSubmit}
        >
          {submitLabel}
        </Button>
      </div>
    </div>
  );
};
